/**
 * Created with IntelliJ IDEA.
 *
 * The item (model/collection) needs to have a 'getMethod' function that returns the fetch method of the item (GET/POST)
 */
define(function (require) {
    "use strict";

    var Logger = require("logger");
    var Marionette = require("marionette");
    var Backbone = require("backbone");
    var BaseModel = require("models/BaseModel");
    var BaseCollection = require("collections/BaseCollection");
    var FetcherItemModel = require("models/FetcherItemModel");
    var BatchelorModel = require("models/BatchelorModel");

    var NameUtility = require("utils/NameUtility");

    var SUCCESS_STATUS_CODE = 200;

    var FetcherController = Marionette.Controller.extend({

        initialize:function () {
            this.logger = Logger.getLogger("LEFramework");
            this.fetcherCollection = new BaseCollection();
        },

        addItem: function(object){
            var item = object.item;
            var itemName = object.itemName;
            var fetchOptions = object.fetchOptions || {};
            var optional = object.optional || {};

            if (this.fetcherCollection.findWhere({name: itemName})) {
                this.logger.error("Model/Collection name must be unique", "FetcherController:addItem");
                this.logger.graph({name:"framework:fetcherController:addItem:uniqueNameErr"});
            }
            else {
                var fetcherItemModel = new FetcherItemModel({
                    name: itemName,
                    model: item,
                    fetchOptions: fetchOptions,
                    headers: _.has(optional, "headers") ? optional.headers : {},
                    doNotMergeHeaders: _.has(optional, "doNotMergeHeaders") ? optional.doNotMergeHeaders : "",
                    body: _.has(optional, "body") ? optional.body : "",
                    timeout: _.has(optional, "timeout") ? optional.timeout : ""
                });

                this.fetcherCollection.add(fetcherItemModel);
            }
        },

        fetchItems: function(options){
            this.fetcherCollection.each(function(model){
                model.initializeFetch();
            });

            var successFunction, errorFunction;

            if(options && _.isFunction(options.success)){
                successFunction = options.success;
            }
            if(options && _.isFunction(options.error)){
                errorFunction = options.error;
            }

            var modelsArray = _.without(this.fetcherCollection.toJSON(), undefined);

            if(modelsArray.length !== 0) { //there are no items to fetch (empty/fresh)
                var batchelorModel = new BatchelorModel(modelsArray);

                batchelorModel.fetch({
                    success: _.bind(function (model, response, options) {
                        _.each(response, function (item, itemKey) {
                            var modelToUpdate = this.fetcherCollection.find(function (model) {
                                return model.get("name") === itemKey;
                            });
                            modelToUpdate.simulateFetch(item.body, item.statusCode === SUCCESS_STATUS_CODE, item.headers);
                        }, this);

                        if (successFunction) {
                            successFunction(model, response, options);
                        }
                    }, this),
                    error: _.bind(function (model, response, options) {
                        this.fetcherCollection.each(function (model) {
                            model.simulateFetch(response, false);
                        });

                        if (errorFunction) {
                            errorFunction(model, response, options);
                        }
                    }, this)
                });
            }
            else{
                if (successFunction) {
                    successFunction(new BatchelorModel(this.fetcherCollection.toJSON()), {}, options); //call the success function with all items (including fresh)
                }
            }
        }
    });

    return FetcherController;
});
